<path
    d="M6 8C6 7.58579 6.33579 7.25 6.75 7.25H12.25C12.6642 7.25 13 7.58579 13 8C13 8.41421 12.6642 8.75 12.25 8.75H6.75C6.33579 8.75 6 8.41421 6 8Z"
    fill="currentColor"
/>
<path
    d="M6.75 9.5C6.33579 9.5 6 9.83579 6 10.25C6 10.6642 6.33579 11 6.75 11H10.25C10.6642 11 11 10.6642 11 10.25C11 9.83579 10.6642 9.5 10.25 9.5H6.75Z"
    fill="currentColor"
/>
<path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3 8.75C3 6.12665 5.12665 4 7.75 4H12.25C14.8734 4 17 6.12665 17 8.75V9.5C17 12.1234 14.8734 14.25 12.25 14.25H10.6241L7.44628 16.6028C7.21864 16.7713 6.91547 16.7972 6.66252 16.6698C6.40957 16.5423 6.25 16.2832 6.25 16V14.0081C4.36171 13.38 3 11.5997 3 9.5V8.75ZM7.75 5.5C5.95507 5.5 4.5 6.95507 4.5 8.75V9.5C4.5 11.0858 5.63655 12.4078 7.13978 12.6929C7.49378 12.7601 7.75 13.0695 7.75 13.4298V14.5115L9.93034 12.8972C10.0595 12.8016 10.2159 12.75 10.3766 12.75H12.25C14.0449 12.75 15.5 11.2949 15.5 9.5V8.75C15.5 6.95507 14.0449 5.5 12.25 5.5H7.75Z"
    fill="currentColor"
/>
